import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { DeviceProvider as SeagullDeviceProvider, ScopedThemeProvider, useDevice } from 'seagull';
import { getDefaultTheme } from '~/constants';
import { useRootDevice } from '~/providers/DeviceProvider';
function ScaledDownFontsOnMobile(param) {
    let { children } = param;
    const { isMobileDevice } = useDevice();
    return isMobileDevice ? /*#__PURE__*/ _jsx(ScopedThemeProvider, {
        theme: getDefaultTheme('mobile'),
        maxHeight: true,
        maxWidth: true,
        children: children
    }) : /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}
export function MobileDeviceEnhancer(param) {
    let { children } = param;
    const { isMobileDevice } = useRootDevice();
    const value = useMemo(()=>({
            isMobileDevice
        }), [
        isMobileDevice
    ]);
    return /*#__PURE__*/ _jsx(SeagullDeviceProvider, {
        value: value,
        children: /*#__PURE__*/ _jsx(ScaledDownFontsOnMobile, {
            children: children
        })
    });
}
